module.exports = __webpack_public_path__ + "img/annual-report.31d935d0.webp";